import React from 'react';
interface SectionBadgeProps {
  children: React.ReactNode;
  color?: 'magenta' | 'lime' | 'aqua';
  className?: string;
}
export function SectionBadge({
  children,
  color = 'magenta',
  className = ''
}: SectionBadgeProps) {
  const styles = {
    magenta: 'border-magenta/40 bg-magenta/10 text-magenta',
    lime: 'border-lime/40 bg-lime/10 text-lime',
    aqua: 'border-aqua/40 bg-aqua/10 text-aqua'
  }[color];
  return <span className={`inline-flex items-center gap-2 rounded-full border px-4 py-1.5 text-xs font-bold uppercase tracking-widest ${styles} ${className}`} data-id="element-16" data-mp="1z0bklbfwilab">
      {children}
    </span>;
}